import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import EmptyState from '~/components/empty-state'
import { LinkButton } from '~/features/navigation'
import { useTRPC } from '~/services/trpc'
import { SettingsActions, SettingsContent, useSettingTitle } from '~/templates/settings'

import { Icon } from '@hap/components'

import { ApiTokenItem } from './-components/api-token-item'

export const Route = createFileRoute('/_authenticated/$alias/settings/api-tokens/')({
  component: ApiTokensSettings,
})

function ApiTokensSettings() {
  const params = Route.useParams()
  const trpc = useTRPC()
  const { data: tokens = [], isLoading } = useQuery(trpc.apiTokens.list.queryOptions())

  useSettingTitle([
    {
      label: 'API Tokens',
      description: 'Create and manage API tokens for integrations like MCP.',
    },
  ])

  return (
    <>
      <SettingsActions>
        <LinkButton
          to="/$alias/settings/api-tokens/new"
          params={params}
          icon="plus"
          variant="lime"
        >
          Token
        </LinkButton>
      </SettingsActions>
      <SettingsContent spacing="sm" className="w-full overflow-y-auto">
        {isLoading ? (
          <div className="grid gap-3">
            {[0, 1, 2].map((index) => (
              <div
                key={index}
                className="bg-accent h-28 animate-pulse rounded-md border"
              />
            ))}
          </div>
        ) : tokens.length ? (
          <div className="grid gap-3">
            {tokens.map((token) => (
              <ApiTokenItem
                key={token.id}
                id={token.id}
                name={token.name}
                description={token.description}
                audience={token.audience}
                scopes={token.scopes}
                createdAt={token.createdAt}
                createdBy={token.createdBy}
                updatedAt={token.updatedAt}
                lastUsedAt={token.lastUsedAt}
                expiresAt={token.expiresAt}
                revokedAt={token.revokedAt}
              />
            ))}
          </div>
        ) : (
          <EmptyState
            icon={<Icon name="key" size={32} weight="fill" />}
            title="API Tokens"
            description="Create an API token to connect approved clients to Happitu insights. Tokens are shown once when they are created."
            actions={[{ label: 'Create token', to: '/$alias/settings/api-tokens/new' }]}
          />
        )}
      </SettingsContent>
    </>
  )
}
